export function TagIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.2477 35.8719C9.06374 35.8719 7.93574 35.4239 7.07174 34.6079C6.15174 33.7359 5.64774 32.5599 5.64774 31.2959L5.50374 10.2079C5.49574 8.58393 6.11974 7.06393 7.25574 5.91193C8.39974 4.75993 9.91974 4.12793 11.5357 4.12793H28.3037C31.6077 4.12793 34.3197 6.81593 34.3437 10.1279L34.4877 31.1039C34.4957 32.3279 34.0237 33.4879 33.1597 34.3599C32.2957 35.2319 31.1037 35.7279 29.8797 35.7279C29.2637 35.7279 28.6557 35.6079 28.0797 35.3599L20.0717 32.0079L12.0957 35.4799C11.5197 35.7359 10.8877 35.8719 10.2397 35.8719H10.2477Z"
        fill="url(#paint0_linear_2659_12283)"
      />
      <path
        d="M31.2881 31.1201C31.2961 32.1281 30.2561 32.8001 29.3281 32.4081L20.0481 28.5281L10.8241 32.5441C9.90414 32.9521 8.84814 32.2961 8.84814 31.2881L8.70414 10.1841C8.69614 8.60812 9.96814 7.32812 11.5441 7.32812H28.3121C29.8721 7.32812 31.1361 8.58413 31.1521 10.1441L31.2961 31.1201H31.2881Z"
        fill="url(#paint1_linear_2659_12283)"
      />
      <path
        opacity="0.27"
        d="M20.0236 24.0961C19.4156 24.0961 18.8236 23.9281 18.3036 23.6081C16.3756 22.4081 13.1276 19.8801 13.1036 16.4961C13.0956 15.3681 13.5516 14.3121 14.3836 13.5201C15.1836 12.7521 16.2476 12.3281 17.3756 12.3201C18.3196 12.3201 19.2396 12.6161 19.9836 13.1281C20.7276 12.6001 21.6316 12.2881 22.5356 12.2881C24.9276 12.2881 26.8556 14.1361 26.8716 16.4001C26.8956 19.7921 23.6876 22.3601 21.7756 23.5921C21.2476 23.9281 20.6396 24.1121 20.0156 24.1121L20.0236 24.0961Z"
        fill="url(#paint2_linear_2659_12283)"
      />
      <path
        d="M17.392 14.04C18.32 14.04 19.16 14.496 19.616 15.112C19.744 15.28 19.984 15.632 19.984 15.632C19.984 15.632 20.256 15.272 20.384 15.104C20.856 14.48 21.688 14.008 22.552 14C23.976 13.992 25.144 15.064 25.152 16.4C25.168 19.016 22.296 21.192 20.848 22.128C20.352 22.448 19.712 22.456 19.208 22.144C17.744 21.232 14.84 19.096 14.824 16.48C14.816 15.144 15.96 14.048 17.392 14.04Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2659_12283"
          x1="15.9005"
          y1="38.7592"
          x2="27.7387"
          y2="5.13131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E300" />
          <stop offset="0.5" stopColor="#00FC00" />
          <stop offset="0.653886" stopColor="#17FC00" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2659_12283"
          x1="20.9975"
          y1="32.4808"
          x2="20.9975"
          y2="7.22167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#075818" />
          <stop offset="1" stopColor="#009D0F" stopOpacity="0.6" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2659_12283"
          x1="13.1036"
          y1="18.1921"
          x2="26.8796"
          y2="18.1921"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8FFB3" />
          <stop offset="1" stopColor="#F0FEB7" />
        </linearGradient>
      </defs>
    </svg>
  )
}
